module.exports = __webpack_public_path__ + "media/images/logo-880aedab2acbfb8efeacd2c6d58e2b4e.png";